import * as progress from "@grindex-components/Progress/progress";
import * as selectBox from "@grindex-client/components/SelectBox/SelectBox";
import modal from "@grindex-components/Modal/modal.js";
import loader from "@grindex-components/Loader/loader";
import cdsFeed from "@grindex-client/components/CdsFeed/cds-feed.module";
import toggleSwitch from "@grindex-client/components/ToggleButton/toggleSwitch";
import header from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.header";
import accordion from "@grindex-components/Accordion/Accordion";
import * as initTable from "@grindex-client/components/Table/extendedTable";
import jwplayerVideo from "@grindex-client/components/Video/jwplayerVideo";
import searchBox from "@grindex-client/components/Search/searchBox";
import tpiDocuments from "@grindex-client/components/Documents/tpiDocuments";
import nativeDocuments from "@grindex-client/components/Documents/nativeDocuments";
import nativeSubmittals from "@grindex-client/components/Documents/nativeSubmittals";
import carousel from "@grindex-client/components/Carousel/Carousel";

const components = [
	progress,
	selectBox,
	modal,
	loader,
	cdsFeed,
	toggleSwitch,
	header,
	accordion,
	initTable,
	jwplayerVideo,
	searchBox,
	tpiDocuments,
	nativeDocuments,
	nativeSubmittals,
	carousel,
];

export { components };
